import { Flex, StyledTd } from "../../../../styled";
import { TimeInput } from "@mantine/dates";
import { ITimelineItemBase } from "../../../../components/shared/TimelineCalendar/timeline.types";
import { Text } from "@mantine/core";
import { useState, useEffect, Fragment } from "react";
import moment from "moment";

interface Props {
  onChangeTime: (
    id: string,
    value: string,
    timeProperty: "start" | "end",
  ) => void;
  item: ITimelineItemBase;
  disabled?: boolean;
}

const VitalsInputTimeCell = ({ item, onChangeTime, disabled }: Props) => {
  const startTime = item.start.split("T")[1].slice(0, 5); // Extract HH:mm
  const endTime = item.end.split("T")[1].slice(0, 5); // Extract HH:mm

  const [isStartTimeError, setIsStartTimeError] = useState(false);
  const [isEndTimeError, setIsEndTimeError] = useState(false);

  useEffect(() => {
    if (disabled) return;
    const start = moment(startTime, "HH:mm");
    const end = moment(endTime, "HH:mm");
    const diffMinutes = end.diff(start, "minutes");
    setIsStartTimeError(startTime > endTime); // Highlight if startTime is after endTime
    const isEndTimeError = endTime < startTime || diffMinutes < 5; // Highlight if endTime is before startTime
    setIsEndTimeError(isEndTimeError); // Highlight if endTime is before startTime
  }, [startTime, endTime, disabled]);

  return (
    <StyledTd key={item.id} style={{ padding: 5 }}>
      <Flex gap={2} align="center">
        {disabled ? (
          <Text>
            {startTime} - {endTime}
          </Text>
        ) : (
          <Fragment>
            <TimeInput
              value={startTime}
              onChange={e => onChangeTime(item.id, e.target.value, "start")}
              error={isStartTimeError}
              styles={{ input: isStartTimeError ? { borderColor: "red" } : {} }}
            />
            <Text> - </Text>
            <TimeInput
              value={endTime}
              onChange={e => onChangeTime(item.id, e.target.value, "end")}
              error={isEndTimeError}
              styles={{ input: isEndTimeError ? { borderColor: "red" } : {} }}
            />
          </Fragment>
        )}
      </Flex>
    </StyledTd>
  );
};

export default VitalsInputTimeCell;
